import CookiesPolicy from "@/views/public/legal/CookiesPolicy.vue";

export default {
  path: "/cookies",
  name: "cookies",
  component: CookiesPolicy
};
